import { render, staticRenderFns } from "./SalesReports.vue?vue&type=template&id=441c3036&"
import script from "./SalesReports.vue?vue&type=script&lang=js&"
export * from "./SalesReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('441c3036')) {
      api.createRecord('441c3036', component.options)
    } else {
      api.reload('441c3036', component.options)
    }
    module.hot.accept("./SalesReports.vue?vue&type=template&id=441c3036&", function () {
      api.rerender('441c3036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/SalesReports.vue"
export default component.exports